var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterIcMsg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "30px",
    viewBox: "0 0 32 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "footerIcMsg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.61,1.6250125 C6.61,0.7886375 7.288625,0.1100125 8.125,0.1100125 C8.961375,0.1100125 9.64,0.7886375 9.64,1.6250125 C9.64,2.4613875 8.961375,3.1400125 8.125,3.1400125 C7.288625,3.1400125 6.61,2.4613875 6.61,1.6250125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(-91.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footerIcMsg",
    transform: "translate(92.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    stroke: "#7EC34D",
    fill: "#7EC34D",
    cx: 14.8809524,
    cy: 12.5,
    rx: 14.8809524,
    ry: 12.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-14",
    fill: "#7EC34D",
    points: "6 23 6 29 13 25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(7.000000, 11.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.36,1.6250125 C0.36,0.7886375 1.038625,0.1100125 1.875,0.1100125 C2.711375,0.1100125 3.39,0.7886375 3.39,1.6250125 C3.39,2.4613875 2.711375,3.1400125 1.875,3.1400125 C1.038625,3.1400125 0.36,2.4613875 0.36,1.6250125 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.86,1.6250125 C12.86,0.7886375 13.538625,0.1100125 14.375,0.1100125 C15.211375,0.1100125 15.89,0.7886375 15.89,1.6250125 C15.89,2.4613875 15.211375,3.1400125 14.375,3.1400125 C13.538625,3.1400125 12.86,2.4613875 12.86,1.6250125 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcMsg);
export default __webpack_public_path__ + "static/media/footerIcMsg.43c0f17a02bc0fcc6a427baa26de2831.svg";
export { ForwardRef as ReactComponent };